import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrigenVenta } from '../../shared/models/system';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class OrigenVentaService {
  private apiUrl = `${environment.apiUrl}/origen-venta`;

  constructor(private http: HttpClient, private auth: Auth) {}

  private getHeaders() {
    const token = this.auth.getToken();
    return {
      headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` })
    };
  }

  getAll(): Observable<OrigenVenta[]> {
    return this.http.get<OrigenVenta[]>(`${this.apiUrl}`, this.getHeaders());
  }

  getActive(): Observable<OrigenVenta[]> {
    return this.http.get<OrigenVenta[]>(`${this.apiUrl}/active`, this.getHeaders());
  }

  create(origenVenta: Partial<OrigenVenta>): Observable<OrigenVenta> {
    return this.http.post<OrigenVenta>(`${this.apiUrl}`, origenVenta, this.getHeaders());
  }

  update(id: number, origenVenta: OrigenVenta): Observable<OrigenVenta> {
    return this.http.put<OrigenVenta>(`${this.apiUrl}/${id}`, origenVenta, this.getHeaders());
  }

  toggle(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, this.getHeaders());
  }
}
